import { createContext, useEffect, useState } from "react";
import { allAppCurrencies, defaultCurrency } from "utils/Currency&Language";

//-------------------------------------------------------------------

export const CurrencyContext = createContext();

export const CURRENCY_KEY = "satyam-currency";
export const CURRENCY_CHANGED_KEY = "satyam-currency-changed";

//-------------------------------------------------------------------

const CurrencyProvider = ({ children }) => {
  const [currency, setCurrency] = useState();

  useEffect(() => {
    initCurrency();
  }, []);

  const initCurrency = () => {
    const currencyLS = JSON.parse(localStorage.getItem(CURRENCY_KEY));

    if (!currencyLS) {
      localStorage.setItem(CURRENCY_KEY, JSON.stringify(defaultCurrency));

      setCurrency(defaultCurrency);
    } else {
      const matchedCurrency = allAppCurrencies.find(
        (item) => item.currency === currencyLS.currency
      );
      setCurrency(matchedCurrency || defaultCurrency);
    }
  };

  const updateCurrency = (newCurrency) => {
    const matchedCurrency = allAppCurrencies.find(
      (item) => item.currency === newCurrency.currency
    );
    if (matchedCurrency) {
      localStorage.setItem(CURRENCY_KEY, JSON.stringify(matchedCurrency));
      setCurrency(matchedCurrency);
    }
  };

  // Change Currency
  const handleChangeCurrency = ({ tokenCurrency, selectedCurrency }) => {
    updateCurrency(selectedCurrency || defaultCurrency);
  };

  return (
    <CurrencyContext.Provider
      value={{
        currency,
        setCurrency: handleChangeCurrency,
      }}
    >
      {children}
    </CurrencyContext.Provider>
  );
};

export default CurrencyProvider;
